export default __webpack_public_path__ + "static/media/6.1175fef1.jpg";